module.exports = __webpack_public_path__ + "static/media/six.e9400453.ogg";